export default "__VITE_ASSET__k2vMXdy6__"